<template>
  <div id="grid-traspaso">
    <div v-if="loading">
      <loading></loading>
    </div>
    <v-container grid-list-xl fluid>
      <v-layout>
        <carga-masiva
          :apiValidateDocument="apiValidateDocument"
          :apiSaveDocument="apiSaveDocument"
          :apiDownloadDocument="apiDownloadDocument"
          :templateTitle="templateTitle"
        ></carga-masiva>
      </v-layout>
      <v-spacer></v-spacer>
      <v-layout justify-center>
        <v-flex xs12 md4>
          <v-select
            v-model="regionValue"
            item-text="nombre"
            item-value="code"
            :items="regionesSelect"
            label="Region"
            data-vv-name="listaRegiones"
          ></v-select>
        </v-flex>
        <v-flex xs12 md4>
          <v-select
            v-model="centroAcopioValue"
            item-text="name"
            item-value="code"
            :items="centroAcopioSelect"
            label="Centro Acopio"
          ></v-select>
        </v-flex>
        <v-flex xs12 md4>
          <v-select
            v-model="fechaValue"
            :items="fechaSelect"
            label="Fecha"
          ></v-select>
        </v-flex>
        <v-flex xs12 md4> </v-flex>
        <v-btn
          fab
          dark
          color="teal"
          title="Filtrar detalle"
          @click="filterCronograma()"
        >
          <v-icon dark>filter_list</v-icon>
        </v-btn>
        <!-- BOTON NO INCLUIDO EN DISEÑO DEBERIA ESTAR -->
        <v-btn
          fab
          dark
          color="red darken-4"
          title="Limpiar filtros"
          @click="clear()"
        >
          <v-icon dark>clear_all</v-icon>
        </v-btn>
      </v-layout>
      <v-layout>
        <v-flex lg12>
          <v-spacer></v-spacer>
          <v-data-table
            :headers="headers"
            :items="itemsCronograma"
            :pagination.sync="miPaginacion"
            hide-actions
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td class="text-xs-left">{{ props.item.nivel.descripcion }}</td>
              <td class="text-xs-left">{{ props.item.region.nombre }}</td>
              <td class="text-xs-left">
                {{ props.item.centroOrigenData.codCentro }}
              </td>
              <td class="text-xs-left">
                {{ props.item.centroDestinoData.codCentro }}
              </td>
              <!-- <td class="text-xs-left">{{ props.item.idMaterial }}</td>  -->
              <td
                v-if="
                  props.item.obserFecha !== undefined &&
                  props.item.obserFecha != null &&
                  props.item.obserFecha != ''
                "
                class="text-xs-left"
              >
                <v-chip :color="getColor()" dark>{{
                  props.item.fecha_movimiento + " "
                }}</v-chip>
              </td>
              <td v-else class="text-xs-left">
                {{ props.item.fecha_movimiento + " " }}
              </td>
              <!-- <td  class="text-xs-left">{{ props.item.fecha_movimientoReal + ' ' + props.item.hora_movimiento}}</td> -->
              <td>
                <div class="text-xs-center">
                  <v-btn
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="green darken-4"
                    small
                    title="Consultar detalle"
                    @click="viewTraspaso(props.item.id)"
                    ><v-icon>remove_red_eye</v-icon>
                  </v-btn>
                  <v-btn
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="blue"
                    small
                    title="Nuevo traspaso"
                    @click="openTraspaso(props.item.id)"
                    ><v-icon>add_alarm</v-icon>
                  </v-btn>
                </div>
              </td>
            </template>
          </v-data-table>
          <!-- LEYENDA TABLA PROVEEDORES -->
          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <div class="text-xs-center">
              <td>
                <template>
                  <v-chip color="orange" dark>Registro con comentario</v-chip>
                  <v-btn
                    class="btn-sigas"
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="green darken-4"
                    small
                  >
                    <v-icon>remove_red_eye</v-icon> </v-btn
                  >&nbsp;Consultar detalle
                </template>
              </td>
              <td>
                <template>
                  <v-btn
                    class="btn-sigas"
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="blue"
                    small
                  >
                    <v-icon>add_alarm</v-icon> </v-btn
                  >&nbsp;Nuevo Traspaso
                </template>
              </td>
            </div>
          </v-card-actions>
          <!--fin iconos leyenda-->
          <!-- PAGINACION -->
          <v-flex xs12 sm6>
            <v-text-field
              value=""
              label="Total de Registros"
              v-model="miPaginacion.totalItems"
              disabled
            ></v-text-field>
          </v-flex>
          <div class="pt-2">
            <v-pagination
              v-model="miPaginacion.page"
              :length="numPaginas"
              :total-visible="7"
              circle
            ></v-pagination>
          </div>
        </v-flex>
      </v-layout>
      <v-card-actions class="pb-3">
        <v-spacer></v-spacer>
        <v-btn
          :loading="loading"
          color="primary"
          dark
          class="mb-2"
          @click="downloadComplete()"
          >Descarga Completa <v-icon right dark>folder</v-icon></v-btn
        >
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
import { misMixins } from "@/mixins/myMixing.js";
import CargaMasiva from "@/components/CargaMasiva.vue";

export default {
  name: "grid-traspaso",
  components: {
    Loading,
    CargaMasiva,
  },
  mixins: [misMixins],
  props: {
    rowsTable: "",
    tipeView: "",
  },

  data() {
    return {
      miPaginacion: {
        rowsPerPage: 20,
        page: 0,
      },
      botonValida: 1,
      loading: false,
      itemsCronograma: [],
      dialogValidation: false,
      dialog: false,
      resp: "",
      contratoId: "",
      itemsProgreso: [],
      headers: [
        { text: "Nivel", align: "left", sortable: false, value: "nivel" },
        { text: "Region", align: "left", sortable: false, value: "region" },
        { text: "Centro Acopio", sortable: false, value: "centroAcopio" },
        { text: "Centro Operacion", sortable: false, value: "centroOperacion" },
        // { text: "ID Material", sortable: false, value: "material" },
        { text: "Fecha Movimiento", sortable: false, value: "fecha" },
        // { text: "Fecha Real", sortable: false, value: "fecha" },
        { text: "Accion", sortable: false, value: "accion" },
      ],
      fechaInicioValue: [],
      usuarioLoggedTipe: "",
      bloqueo: Boolean,
      itemsMateriales: [],
      centroAcopio: "",
      centroAcopioValue: null,
      centroAcopioSelect: [],
      nivelValue: null,
      nivelSelect: [],
      tipoMaterialValue: null,
      tipoMaterialSelect: [],
      regionValue: null,
      regionesSelect: [],
      fechaValue: null,
      fechaSelect: [],
      resultadoValue: null,
      resultadoSelect: [],
      filter: false,
      tabSelected: "",
      tipeArchive: "",
      filex: "",
      //----CARGA MASIVA---
      apiValidateDocument: "",
      apiSaveDocument: "",
      apiDownloadDocument: "",
      templateTitle: "",
    };
  },
  created() {
    this.loading = true;
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;
    this.idContrato = this.$store.getters.contratoStored;
    this.tabSelected = this.$store.getters.subTabSelectedStored;
    //se indican las apis a utilizar
    this.apiValidateDocument = "/traspaso/preProcessTraspasoMasivo";
    this.apiSaveDocument = "/traspaso/guardarTraspasosMasivo/CA-CO";
    this.apiDownloadDocument = "/traspaso/downloadPlantillaTraspaso/";
    this.templateTitle = "Planilla_Traspaso_CA_CO";
    this.loadDataComuna();
    this.loadData();
  },
  mounted() {},
  computed: {
    numPaginas() {
      if (
        this.miPaginacion.rowsPerPage == null ||
        this.miPaginacion.totalItems == null
      ) {
        return 0;
      }

      return Math.ceil(
        this.miPaginacion.totalItems / this.miPaginacion.rowsPerPage
      );
    },
  },
  methods: {
    getColor() {
      return "orange";
    },
    openTraspaso(id) {
      setTimeout(() => {
        this.$router.push({
          name: "FormTraspasoCO",
          params: {
            idTraspaso: id,
            tipeView: "crear",
            titleView: "Nuevo Traspaso",
          },
        });
      }, 1000);
    },

    viewTraspaso(id) {
      setTimeout(() => {
        this.$router.push({
          name: "FormTraspasoCO",
          params: {
            idTraspaso: id,
            tipeView: "consulta",
            titleView: "Consulta Traspaso",
          },
        });
      }, 1000);
    },

    async loadCronogramaFilter() {
      let that = this;
      let subTab = this.$store.getters.subTabSelectedStored;
      let proceso = this.$store.getters.proSelectedStored;
      let idContrato = this.$store.getters.contratoStored;

      this.body = {
        region:
          this.regionValue && this.regionValue != null
            ? this.regionValue
            : null,
        centroCaCo:
          this.centroAcopioValue && this.centroAcopioValue != null
            ? this.centroAcopioValue
            : null,
        centroCoCa: null,
        fechaMovimiento:
          this.fechaValue && this.fechaValue != null ? this.fechaValue : null,
        fechaMovimientoCoCa: null,
        tipoTraspaso: "CA-CO",
        idContrato: idContrato,
      };

      return await axios
        .post("/traspaso/traspasoFilter", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          }
          return [];
        });
    },

    async loadData() {
      this.loading = true;
      this.itemsCronograma = await this.loadCronogramaFilter();
      this.miPaginacion.totalItems = this.itemsCronograma.length;
      this.loading = false;
      if (this.itemsCronograma.length > 0) {
        this.loadCentroSelect();
        this.loadFechaSelect();
      }
    },

    loadRegionSelect() {
      let reg = [];
      this.itemsCronograma.forEach(function (c) {
        let index = reg.findIndex((x) => x.region == c.region.nombre);
        if (index === -1) {
          reg.push(c.region.nombre);
        }
      });
      this.regionSelect = reg;
    },

    loadCentroSelect() {
      let com = [];
      this.itemsCronograma.forEach(function (c) {
        let index = com.findIndex((x) => x.centroOrigen == c.centroOrigen);
        if (index === -1) {
          com.push({
            name: c.centroOrigenData.codCentro,
            code: c.centroOrigen,
          });
        }
      });
      this.centroAcopioSelect = com;
    },
    loadFechaSelect() {
      let est = [];
      this.itemsCronograma.forEach(function (c) {
        let index = est.findIndex(
          (x) => x.fecha_movimiento == c.fecha_movimiento
        );
        if (index === -1) {
          est.push(c.fecha_movimiento);
        }
      });
      this.fechaSelect = est;
    },
    clear() {
      this.regionValue = "";
      this.centroAcopioValue = "";
      this.fechaValue = "";
      this.loadData();
    },
    //SOLO NUMEROS
    bloqueoEdicion(tip) {
      if (tip == "AGENCIA") {
        this.bloqueo = true;
      }
      if (tip == "PROVEEDOR") {
        this.bloqueo = false;
      }
      return this.bloqueo;
    },

    filterCronograma() {
      this.filter = true;
      this.loadData();
    },

    downloadComplete() {
      let idContrato = this.$store.getters.contratoStored;
      let fileName = "Registro_Traspaso.xlsx";
      this.body = {
        idContrato: idContrato,
        region:
          this.regionValue && this.regionValue != null
            ? this.regionValue
            : null,
        centro:
          this.centroAcopioValue && this.centroAcopioValue != null
            ? this.centroAcopioValue
            : null,
        fechaMovimiento:
          this.fechaValue && this.fechaValue != null ? this.fechaValue : null,
        tipoTraspaso: "CA-CO",
      };
      axios
        .post("/traspaso/DescargaMasivaToExcelTraspaso", this.body, {
          responseType: "blob",
        })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
  },
};
</script>
